import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9adac87a")

_pushScopeId("data-v-9adac87a")
const _hoisted_1 = {
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "stop-title" }
const _hoisted_4 = { class: "stop-title" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = {
  class: "table-fixed b-none",
  style: {"max-height":"265px"}
}
const _hoisted_8 = { class: "table mb-0" }
const _hoisted_9 = { class: "w-min" }
const _hoisted_10 = { class: "align-middle text-nowrap" }
const _hoisted_11 = { class: "align-middle text-nowrap" }
const _hoisted_12 = { class: "align-middle text-nowrap" }
const _hoisted_13 = { class: "align-middle text-nowrap" }
const _hoisted_14 = { class: "align-middle text-nowrap" }
const _hoisted_15 = {
  key: 0,
  class: "icon-f fs-9 icon-infinity"
}
const _hoisted_16 = { class: "align-middle text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = $event)),
    contentClass: "modal-limit",
    modalWidth: 590
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.history.title')) + " ", 1),
            _createVNode("b", null, _toDisplayString(_ctx.product.name), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("b", null, _toDisplayString(_ctx.slot.startTime) + " - " + _toDisplayString(_ctx.slot.endTime), 1)
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('calendar.v3.modal.history.description')), 1)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("table", _hoisted_8, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.history.start_date')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.history.start_time')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.history.end_time')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.history.duration')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.history.limit')), 1),
                _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('calendar.v3.modal.history.revert')), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slots, (slot) => {
                return (_openBlock(), _createBlock("tr", {
                  key: slot.id
                }, [
                  _createVNode("td", _hoisted_10, _toDisplayString(_ctx.getDateToTitle(slot.startDate)), 1),
                  _createVNode("td", _hoisted_11, _toDisplayString(_ctx.getTime(slot.startTime)), 1),
                  _createVNode("td", _hoisted_12, _toDisplayString(_ctx.getTime(slot.endTime)), 1),
                  _createVNode("td", _hoisted_13, _toDisplayString(_ctx.getTime(slot.duration)), 1),
                  _createVNode("td", _hoisted_14, [
                    _createTextVNode(_toDisplayString(slot.limit) + " ", 1),
                    (!slot.limit)
                      ? (_openBlock(), _createBlock("i", _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_16, [
                    _createVNode("i", {
                      class: ["icon-f icon-history fs-18 c-blue", { disabled: _ctx.today > new Date(slot.startDate) }],
                      onClick: ($event: any) => (_ctx.revert(slot))
                    }, null, 10, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode("button", {
        class: "close-button-wrapper popup-bookit-button px-5",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, _toDisplayString(_ctx.$t('button.close')), 1)
    ]),
    _: 1
  }, 8, ["isOpen"]))
})